// extracted by mini-css-extract-plugin
module.exports = {"bodywrapper":"companypublicprofile_bodywrapper__1yb5z","page-title":"companypublicprofile_page-title__29FIM","watermark":"companypublicprofile_watermark__3v0hH"};